import { useQuery } from '@tanstack/react-query';

import { getKpisWithLatestEntries } from '@/features/dashboard/api/get-kpis-with-latest-entries';
import { useProjects } from '@/features/projects/shared/hooks/use-projects';

export const getKpisWithLatestEntriesQueryKey = (projectIds: number[]) => [
  'kpis-with-latest-entries',
  projectIds.sort(),
];

export type KpiWithLatestEntry = Awaited<
  ReturnType<typeof getKpisWithLatestEntries>
>[number];

export const useKpisWithLatestEntries = () => {
  const { data: projects = [], isLoading: isProjectsLoading } = useProjects();

  return useQuery({
    queryKey: getKpisWithLatestEntriesQueryKey(projects.map((p) => p.id)),
    queryFn: async () => {
      if (isProjectsLoading || projects.length === 0) {
        return [];
      }
      return getKpisWithLatestEntries(projects);
    },
    enabled: !isProjectsLoading && projects.length > 0,
  });
};
